import * as React from 'react';
export const LISvg = React.forwardRef(function LISvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M1.994 2A1.998 1.998 0 0 0 0 3.998V8h16V3.998A1.997 1.997 0 0 0 14.006 2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        fillRule: 'nonzero',
        d: 'M6 6v1H2V6a2 2 0 1 1 4 0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 8v4.002C0 13.106.895 14 1.994 14h12.012A1.998 1.998 0 0 0 16 12.002V8H0Z',
      }),
    ),
  );
});
LISvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var LI = {
  category: 'flag',
  colorable: false,
  name: 'LI',
  svg: LISvg,
};
